import React, { useState, useEffect } from 'react';
import {
    Box,
    Text,
    Switch,
    VStack,
    HStack,
    Button,
    FormControl,
    FormLabel,
    Divider,
    Tag,
    useToast,
} from '@chakra-ui/react';
import { fetchWrapper } from '../../helpers';

const StoryBuilderAI = ({ id, customer }) => {
    const [isEnabled, setIsEnabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    useEffect(() => {
        setIsEnabled(customer?.ai_allowed === true || customer?.ai_allowed === 1);
    }, [customer?.ai_allowed]);

    const handleSave = async () => {
        setLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_URL}/customer/ai-allowed`;
            await fetchWrapper.post(url, { customer_id: id, ai_allowed: isEnabled });
            toast({ title: 'Story Builder AI setting saved', status: 'success', duration: 3000, isClosable: true });
        } catch (error) {
            toast({ title: 'Failed to save setting', status: 'error', duration: 3000, isClosable: true });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box maxW="560px" p={4}>
            <Text fontSize="15px" fontWeight="600" color="#111827" mb={1}>Story Builder AI</Text>
            <Text fontSize="13px" color="#6b7280" mb={4}>
                Enable or disable the Story Builder AI feature for this customer.
            </Text>

            <Divider mb={5} />

            <VStack spacing={6} align="stretch">
                <FormControl>
                    <HStack justify="space-between" align="center">
                        <Box>
                            <HStack spacing={2} mb={1}>
                                <FormLabel htmlFor="story-builder-ai" mb={0} fontSize="14px" fontWeight="500" color="#111827">
                                    Story Builder AI
                                </FormLabel>
                                <Tag colorScheme={isEnabled ? 'green' : 'gray'} fontSize="10px">
                                    {isEnabled ? 'Enabled' : 'Disabled'}
                                </Tag>
                            </HStack>
                            <Text fontSize="12px" color="#6b7280">
                                When enabled, this customer can use the AI-powered story builder to create and manage message stories.
                            </Text>
                        </Box>
                        <Switch
                            id="story-builder-ai"
                            size="lg"
                            colorScheme="blue"
                            isChecked={isEnabled}
                            onChange={(e) => setIsEnabled(e.target.checked)}
                        />
                    </HStack>
                </FormControl>

                <Button
                    colorScheme="blue"
                    size="sm"
                    onClick={handleSave}
                    isLoading={loading}
                    loadingText="Saving..."
                    alignSelf="flex-start"
                >
                    Save Settings
                </Button>
            </VStack>
        </Box>
    );
};

export default StoryBuilderAI;
